module.exports = __webpack_public_path__ + "static/media/EventSellingCost.cdbd9f2d.png";